import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getRouteUploads, getRouteDownloads } from "../../api/adminApi";
import Pagination from "../common/Pagination";
import Spinner from "../common/Spinner";
import moment from "moment";

function DownloadedRoutesControl(
    {
        user
    }
) {

    const [processing, setProcessing] = useState(true);
    const [resultingRoutes, setResultingRoutes] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState({
        pageNumber: "1",
        itemsPerPage: "12",
        sortDirection: "Descending",
        sortBy: "DateAdded",
        keywords: "",
    });

    useEffect(() => {
        if (resultingRoutes.length == 0) {
            reloadRoutes(searchCriteria)
        }
    }, []);

    function reloadRoutes(criteria) {
        setProcessing(true);
        getRouteDownloads(criteria)
            .then(results => {
                setResultingRoutes(results);
                setProcessing(false);
            })
            .catch(error => {
                console.error(error);
                setProcessing(false);
            })
    }


    function handleChange(e) {
        var value = e.target.value

        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            keywords: value
        }));
    }

    function handleSearch(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        reloadRoutes(criteria);
    }

    function handlePageForward(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = resultingRoutes.pageNumber + 1
        reloadRoutes(criteria);
    }

    function handlePageBack(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = resultingRoutes.pageNumber - 1
        reloadRoutes(criteria);
    }

    function handlePageChange(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = e.target.value
        reloadRoutes(criteria);
    }

    function handleType(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        criteria.sortBy = e.target.value
        reloadRoutes(criteria);
    }

    return (
        <React.Fragment>
            <div className="profile-network col-12">
                <div className="search-toolbar top-form col-md-12 col-lg-12">
                    <form onSubmit={handleSearch} >
                        <div className="order-users">
                            <select className="form-control form-control-sm" id="sortBy" value={searchCriteria.sortBy} onChange={handleType}>
                                <option value="DateAdded">Date Added</option>
                                <option value="Name">Name</option>
                                <option value="Category">Category</option>
                                <option value="Owner">Owner</option>
                            </select>
                        </div>
                        <div className="user-search">
                            <div className="input-group mb-0">
                                <input type="text" className="form-control form-control-sm" value={searchCriteria.keywords} onChange={handleChange} placeholder="Search..." aria-label="Keyword Search" />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={handleSearch}></span></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {processing ?
                    <Spinner />
                    :
                    <React.Fragment>
                        <div className="row justify-content-md-center mt-3">
                            <table className="table col-11">
                                <thead>
                                    <tr>
                                        <th>Downloaded</th>
                                        <th>Name</th>
                                        <th>Category</th>
                                        <th>Owner</th>
                                        <th>Download Method</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        resultingRoutes.results.map((route) => {
                                            return (
                                                <tr key={route.routeId}>
                                                    <td>{moment(route.dateAdded).format("DD/MM/YYYY : hh:mma")}</td>
                                                    <td><Link to={"/route/" + route.routeId}>{route.name}</Link></td>
                                                    <td>{route.category}</td>
                                                    <td>{route.owner}</td>
                                                    <td>{route.downloadMethod}</td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        {resultingRoutes.totalFilteredResults > resultingRoutes.resultsPerPage &&
                            <Pagination
                                totalResults={resultingRoutes.totalFilteredResults}
                                currentPage={resultingRoutes.pageNumber}
                                pageSize={resultingRoutes.resultsPerPage}
                                onPageBack={handlePageBack}
                                onPageForward={handlePageForward}
                                onChangePage={handlePageChange} />
                        }
                    </React.Fragment>

                }
            </div>
        </React.Fragment>
    );
}

DownloadedRoutesControl.propTypes = {
    user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadedRoutesControl);



// WEBPACK FOOTER //
// ./src/components/administration/DownloadedRoutesControl.js